import Model, { attr, hasMany } from '@ember-data/model';
import type AccountingTransactionModel from './accounting-transaction.ts';
import type AccountingInvoiceModel from './accounting-invoice.ts';
import type Store from '@ember-data/store';
import { service } from '@ember/service';
import { Type } from '@warp-drive/core-types/symbols';

export default class AccountingPaymentModel extends Model {
  @service declare store: Store;

  @attr declare paymentDate: string;
  @attr declare description: string;
  @attr declare state: string;
  @attr declare tag: string;
  @attr declare messageId: string;
  @attr declare paymentPath: string;
  @attr declare stats: Record<string, unknown>;
  @attr declare amount: number;
  @attr declare total: number;
  @attr declare achAmount: number;
  @attr declare checkAmount: number;

  /*************************
   **  Relationships      **
   *************************/

  @hasMany('accounting-transaction', { async: false, inverse: null })
  declare accountingTransactions: AccountingTransactionModel[];

  @hasMany('accounting-invoice', { async: false, inverse: null })
  declare accountingInvoices: AccountingInvoiceModel[];

  /**************************
   **  Computed Properties **
   **************************/

  get isCreated() {
    return this.state === 'CREATED';
  }

  [Type] = 'accounting-payment' as const;
}
